import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Terren
 * id E0043E71-ED74-419B-82A9-10D678DF74B3
 * name file-account-outline
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-account-outline.svg
 * tags
 * - Files / Folders 
 * - Account / User 
 */
export const FileAccountOutlineIcon = createSvgIcon(<><path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M13 13C13 14.1 12.1 15 11 15S9 14.1 9 13 9.9 11 11 11 13 11.9 13 13M15 18V19H7V18C7 16.67 9.67 16 11 16S15 16.67 15 18Z" /></>, 'FileAccountOutlineIcon');
export default FileAccountOutlineIcon